import * as React from "react";
import { TextInputEditor, type ParseResult } from "../internal/text-input-editor";

export type NumberValue = number | null;

export function NumberEditor({
  value,
  onCommit,
  onCancel,
}: {
  value: NumberValue;
  onCommit: (next: NumberValue) => void;
  onCancel: () => void;
}) {
  const parse = React.useCallback((draft: string): ParseResult<NumberValue> => {
    const trimmed = draft.trim();
    if (trimmed === "") return { ok: true, value: null };
    const parsed = Number(trimmed);
    // Refuse to commit NaN / non-finite; leave the editor open.
    if (!Number.isFinite(parsed)) return { ok: false };
    return { ok: true, value: parsed };
  }, []);

  return (
    <TextInputEditor<NumberValue>
      initial={value == null ? "" : String(value)}
      parse={parse}
      onCommit={onCommit}
      onCancel={onCancel}
      inputType="number"
      inputMode="decimal"
      step="any"
    />
  );
}
